import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const REQUIREMENTS = [
  {
    key: 'length',
    labelKey: 'verifyEmail.req.length',
    test: (p) => p.length >= 12,
  },
  {
    key: 'upper',
    labelKey: 'verifyEmail.req.upper',
    test: (p) => /[A-Z]/.test(p),
  },
  {
    key: 'lower',
    labelKey: 'verifyEmail.req.lower',
    test: (p) => /[a-z]/.test(p),
  },
  {
    key: 'number',
    labelKey: 'verifyEmail.req.number',
    test: (p) => /[0-9]/.test(p),
  },
  {
    key: 'special',
    labelKey: 'verifyEmail.req.special',
    test: (p) => /[!@#$%^&*(),.?":{}|<>]/.test(p),
  },
];

export function PasswordStrengthChecklist({ password = '' }) {
  const { t } = useTranslation();

  return (
    <ul className="space-y-1 mt-2">
      {REQUIREMENTS.map(({ key, labelKey, test }) => {
        const met = password.length > 0 && test(password);
        return (
          <li
            key={key}
            className={`flex items-center gap-2 text-xs transition-colors ${
              met ? 'text-green-600 dark:text-green-400' : 'text-muted-foreground'
            }`}
          >
            {met ? (
              <Check className="h-3.5 w-3.5 shrink-0" />
            ) : (
              <div className="h-3.5 w-3.5 rounded-full border border-muted-foreground/40 shrink-0" />
            )}
            {t(labelKey)}
          </li>
        );
      })}
    </ul>
  );
}

export default PasswordStrengthChecklist;
